import { AuxiliumComponent } from "../auxilium-component";

export default class ProgressItem extends AuxiliumComponent {
	static observableBooleans = ["active"];

	parsedCallback() {
		this.prepend(document.createElementWithContents("div", null, { className: "progress-item__icon" }));
	}

	attributeChanged(name) {
		if (name === "active" && this.parentElement?.nodeName === "LI") {
			this.parentElement.toggleClass("progress-item--active", this.active);
		}
	}
}
